import axios from "axios";
import useAuthStore from "@src/stores/authStore";
import registrationStore from "@src/stores/registrationStore";
import toast from "react-hot-toast";

const axiosInstance = axios.create({
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
});

// Le backend déduit le parcours (personne morale ou physique) de chaque requête : sans ce paramètre,
// il cherche et contrôle la demande d'une ouverture personne physique.
axiosInstance.interceptors.request.use((config) => {
    const isRegistrationCall = config.url?.startsWith('/hub/registration');
    // Déjà présent dans l'URL : un doublon arriverait en tableau côté Express
    const hasRegistrationType = config.url?.includes('registrationType=') || config.params?.registrationType;

    if (isRegistrationCall && !hasRegistrationType) {
        config.params = { ...config.params, registrationType: 'company' };
    }

    return config;
});

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 403 && !registrationStore.getState().registration.partner_informations.is_partner) {
            toast.dismiss();
            toast.error("Session expirée, veuillez vous reconnecter");
            useAuthStore.getState().openLoginModal();
            error.isHandled = true;
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
